import script from "./AdtCate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdtCate.vue?vue&type=script&lang=ts&setup=true"

import "./AdtCate.vue?vue&type=style&index=0&id=238af7e6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238af7e6"]])

export default __exports__